/**
 * Centralized translations for Change Password module
 * Contains all labels used across change password components
 */

export const ChangePasswordScreenLabels = {
    it: {
        changePassword: 'Cambia Password',
        newPassword: 'Nuova Password',
        confirmNewPassword: 'Conferma Nuova Password',
        submit: 'Invia',
        passwordsDoNotMatch: 'Le password non coincidono',
        pleaseMakeSureYourPasswordsMatch: 'Assicurati che le password inserite siano identiche',
        passwordChangedSuccessfully: 'Password modificata con successo',
        error: 'Errore',
        anErrorOccurredWhileChangingThePassword: 'Si è verificato un errore durante la modifica della password',
        login: 'Login',
        cancel: 'Annulla',
        lowercase: 'La password deve contenere almeno una lettera minuscola',
        uppercase: 'La password deve contenere almeno una lettera maiuscola',
        number: 'La password deve contenere almeno un numero',
        minLength: 'La password deve contenere almeno 12 caratteri',
        symbols: 'La password deve contenere almeno un simbolo',
        notUsedRecently: 'La password non deve essere uguale ad una delle ultime 5',
        passwordRequirements: 'Requisiti Password',
        home:"Home"
    },
    
    en: {
        changePassword: 'Change Password',
        newPassword: 'New Password',
        confirmNewPassword: 'Confirm New Password',
        submit: 'Submit',
        passwordsDoNotMatch: 'Passwords do not match',
        pleaseMakeSureYourPasswordsMatch: 'Please make sure your passwords match',
        passwordChangedSuccessfully: 'Password changed successfully',
        error: 'Error',
        anErrorOccurredWhileChangingThePassword: 'An error occurred while changing the password',
        login: 'Login',
        cancel: 'Cancel',
        lowercase: 'Password must contain at least one lowercase letter',
        uppercase: 'Password must contain at least one uppercase letter',
        number: 'Password must contain at least one number',
        minLength: 'Password must contain at least 12 characters',
        symbols: 'Password must contain at least one symbol',
        notUsedRecently: 'Password must not be the same as one of the last 5',
        passwordRequirements: 'Password Requirements',
        home:'Home'
    }
}; 